import { Component, OnInit } from '@angular/core';
import { EmailViewComponent } from '@modules/search/components/doc-view/components/email-view/email-view.component';
import { LoaderComponent } from '../loader/loader.component';
import {
  IProject,
  ProjectService,
} from '@core/services/project/project.service';
import { DocContainerComponent } from '../../../modules/search/components/doc-view/components/doc-container/doc-container.component';

@Component({
  selector: 'app-new-tab',
  standalone: true,
  imports: [EmailViewComponent, LoaderComponent, DocContainerComponent],
  templateUrl: './new-tab.component.html',
  styleUrl: './new-tab.component.scss',
})
export class NewTabComponent implements OnInit {
  constructor(private _project: ProjectService) {}
  data: any;
  isLoading: boolean = true;
  fileType: string = '';
  ngOnInit(): void {
    let currentProject: any = localStorage.getItem('currentProject');
    currentProject = currentProject ? JSON.parse(currentProject) : null;
    if (currentProject) {
      let parsedCurrentProject: IProject = currentProject;
      this._project.currentProject.set(parsedCurrentProject);
      localStorage.removeItem('currentProject');
    }

    let newTabData = localStorage.getItem('newTabData');
    if (newTabData) {
      this.isLoading = false;
      this.data = JSON.parse(newTabData);
      this.fileType = this.data?._source?.fileType;
      localStorage.removeItem('newTabData');
      document.documentElement.style.setProperty(`--topNav-height`, `-3.5rem`);
    }
  }
}
